import { render, staticRenderFns } from "./TemplateDownload.vue?vue&type=template&id=5c1133df&scoped=true&"
import script from "./TemplateDownload.vue?vue&type=script&lang=js&"
export * from "./TemplateDownload.vue?vue&type=script&lang=js&"
import style0 from "./TemplateDownload.vue?vue&type=style&index=0&id=5c1133df&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c1133df",
  null
  
)

export default component.exports